import { combineReducers } from 'redux';
import RecordTypeReducer from './record/reducer_record_types';
import RecordFieldsReducer from './record/reducer_record_fields';
import RecordExportHistory from './record/reducer_record_export_history';
import RecordPreview from './record/reducer_record_preview';

export const recordReducer = combineReducers({
  record_types: RecordTypeReducer,
  record_fields: RecordFieldsReducer,
  record_run_history: RecordExportHistory,
  preview: RecordPreview,
});
